import { Component, ViewChild, ElementRef, OnInit, Input } from '@angular/core';
import { CommonService } from '../services/common.service';
import { Container, Content, Documento, Authorization, AADUsers, SharePointresponse } from '../models/data.model';
import { NgbDateStruct, NgbCalendar, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AuthGuardService } from '../services/authGuard';
import { Router } from '@angular/router';
import { PhoneBookComponent } from '../phone-book/phone-book.component';
import { Token } from '../models/data.model';
import { DataService } from '../services/data.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { UserComponent } from '../user/user.component';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  // setta il BASE_URL per tutte le istanze di CommonService costruite tramite DI
  /*
  providers: [
    { provide: 'BASE_URL', useValue: 'http://localhost:7990' }
  ]
  */
})

export class HomeComponent implements OnInit {
  @ViewChild("partA", { read: ElementRef }) partA: ElementRef;
  @ViewChild("partB", { read: ElementRef }) partB: ElementRef;
  @ViewChild("partC", { read: ElementRef }) partC: ElementRef;
  @ViewChild("partD", { read: ElementRef }) partD: ElementRef;
  @ViewChild("partE", { read: ElementRef }) partE: ElementRef;

  constructor(private containerService: CommonService<Container>,
    private contentService: CommonService<Content>, private calendar: NgbCalendar,
    private loadingBar: LoadingBarService, private authService: AuthGuardService, private router: Router,
    private modalService: NgbModal, private tokenService: CommonService<Token>,
    private dataService: DataService,
    public translate: TranslateService,
    private aadService: CommonService<AADUsers>) { }

  partAContainers: Container[] = [];
  partBContainers: Container[] = [];
  partCContainers: Container[] = [];
  partDContainers: Container[] = [];
  partEContainers: Container[] = [];
  documents: Documento[] = [];
  pipe;
  date: { year: number, month: number };
  calendarModel: NgbDateStruct;
  bgColors: any[] = ['mat-card-header-rose', 'mat-card-header-primary', 'mat-card-header-warning', 'mat-card-header-success', 'mat-card-header-info'];
  profile: Authorization = { username: '', password: '', group: '' };//=this.authService.getProfile();
  locale: string;

  ngOnInit(): void {
    this.checkPrinciples().then(() => {
      this.initPageFunctions();
      this.locale = this.translate.currentLang;
      this.pipe = new DatePipe(this.locale);
      //this.getUsers();
    });
  }

  getUsers = () => {
    let url = 'api/rest/getAADUsers';
    let params = { params: {} };
    //this.utenti = this.aadService.getData(url,params,false) as Observable<Array<AADUsers>>;
    this.aadService.getData(url, params, true).subscribe(result => {
      let items = result as AADUsers[];
      this.dataService.fetchUtentiAAD(items);
      //console.log("this is list of users : ",this.utenti);
    });
  }

  checkPrinciples = () => {
    return new Promise((resolve, reject) => {
      if (!this.authService.isLoggedIn()) {
        this.authService.ImLogged(undefined, undefined).then(
          (result) => {
            // let res = result as boolean;
            if (result) {
              this.profile = this.authService.getProfile();
              //console.log('this is profile : ', this.profile);
              resolve();
            }
          },
          (error) => this.router.navigate(['/openIdLogin'])
        );
      }
      else {
        this.profile = this.authService.getProfile();
        resolve();
      }
    })
  }

  getDynamicContent = (container: Container) => {
    return new Promise((resolve, reject) => {

      let url = 'api/rest/dynamicPreviewList';
      //let params = { params: { function: 'getItemsFromList',item:'News',list:'News',viewname:'Tutti gli elementi',maxitems:5,ascendingsort:false } };
      let params = { params: {} };
      container.dynPreviewParams.split(',').forEach(item => {
        let param = item.split(':');
        params.params[param[0]] = param[1];
      });
      this.containerService.getData(url, params, false).subscribe(result => {
        if (result != null) {
          resolve(result);
        }
      }, error => reject(error));
    });
  }

  initPageFunctions = () => {
    /* Part B Box in evidenza al centro in alto*/
    this.fetchContainersAsync(this.partB.nativeElement.id, true).then((result) => {
      console.log('this is part B : ', result);
      this.partBContainers = result as Container[];
    })

    /* Part D Icone a sinistra */
    this.fetchContainersAsync(this.partD.nativeElement.id, true).then((result) => {
      console.log('this is part D : ', result);
      this.partDContainers = result as Container[];

      /* Part C - Box Link es.sharepoint al centro in basso */
      this.fetchContainersAsync(this.partC.nativeElement.id, false).then(
        (result) => {
          this.partCContainers = result as Container[];
          this.partCContainers = this.partCContainers.sort((a, b) => a['order'] > b['order'] ? 1 : a['order'] === b['order'] ? 0 : -1);
          let bgIndex = 0;
          console.log('partCContainers', this.partCContainers);
          for (let i = 0; i < this.partCContainers.length; i++) {
            this.partCContainers[i].isLoadFinished = false;
            if (this.partCContainers[i].dynPreviewUrl === 'sharepointList' && this.partCContainers[i].dynPreviewParams !== 'TO BE DEFINED') {
              let content: Content = new Content();
              this.getDynamicContent(this.partCContainers[i]).then((result) => {
                let res = result as SharePointresponse;
                console.log('this is result of sharepoint content', res.result);
                let listResult: any[] = res.result;
                if (listResult.length > 0) {
                  let html = "<table class='table table-hover table-striped'><tbody>";
                  listResult.forEach(x => {
                    let link = this.partCContainers[i].staticPreviewUrl + "?ID=" + x.ID;
                    html += "<tr><td width='90%'  class='pointer'><a href='" + link + "' target='_blank'>" + x.Title + "</a></td><td width='10%'>" + this.pipe.transform(x.Modified, 'shortDate') + "</td></tr>";
                  });
                  html += "</tbody></table>";
                  //html += "<br/> <a href='' target='_blank'>"+  +"</a>"
                  content.htmlContent = html;
                  this.partCContainers[i].contents = [content];
                }
                this.partCContainers[i].isLoadFinished = true;
                console.log('Content result is : ', this.partCContainers[i].tooltip, result);
              }, (error) => {
                this.partCContainers[i].isLoadFinished = true;
                this.partCContainers[i].contents = [content];
                console.log('Dynamic Content rejected : ', error);
              });
            }
            else if (this.partCContainers[i].dynPreviewUrl === 'sharepointFiles' && this.partCContainers[i].dynPreviewParams !== 'TO BE DEFINED') {
              let content: Content = new Content();
              this.getDynamicContent(this.partCContainers[i]).then((result) => {
                let res = result as SharePointresponse;
                let listResult: any[] = res.result;
                if (listResult.length > 0) {
                  let html = "<table class='table table-hover table-striped'><tbody>";
                  listResult.forEach(x => {
                    let link = x.LinkingUri;
                    html += "<tr><td width='90%'  class='pointer'><a href='" + link + "' target='_blank'>" + x.Name + "</a></td><td width='10%'>" + this.pipe.transform(x.TimeLastModified, 'shortDate') + "</td></tr>";
                  });
                  html += "</tbody></table>";
                  //html += "<br/> <a href='' target='_blank'>"+  +"</a>"
                  content.htmlContent = html;
                  this.partCContainers[i].contents = [content];
                }
                this.partCContainers[i].isLoadFinished = true;
                console.log('Content result is : ', result);

              }, (error) => {
                this.partCContainers[i].isLoadFinished = true;
                this.partCContainers[i].contents = [content];
                console.log('Dynamic Content rejected : ', error);
              });
            }
            else if (this.partCContainers[i].dynPreviewUrl === 'arcadocList') {
              let content: Content = new Content();
              this.getDynamicContent(this.partCContainers[i]).then((result) => {
                let listResult: any[] = result as any[];
                if (listResult.length > 0) {
                  let html = "<table class='table table-hover table-striped'><tbody>";
                  listResult.forEach(x => {
                    //let link = x.LinkingUri;

                    html += "<tr><td class='pointer'><a target='_blank' href='"+ environment.baseUrl + "arcadocqualita-detail/" + x.idDocumento + "'>" + x.codiceDocumento + "</a></td></tr>";
                  });
                  html += "</tbody></table>";
                  //html += "<br/> <a href='' target='_blank'>"+  +"</a>"
                  content.htmlContent = html;
                  this.partCContainers[i].contents = [content];
                }
                this.partCContainers[i].isLoadFinished = true;
                console.log('Content result is : ', result);

              }, (error) => {
                this.partCContainers[i].isLoadFinished = true;
                this.partCContainers[i].contents = [content];
                console.log('Dynamic Content rejected : ', error);
              });
            }
            else if (this.partCContainers[i].dynPreviewUrl !== 'sharepointList') {
              this.fetchContentByIdContainerAsync(this.partCContainers[i].id).then(
                (result) => {
                  let contents = result as Content[];
                  this.partCContainers[i].contents = contents;
                  if (contents.length > 0) {
                    //console.log('this is part C contents for ',this.partCContainers[i].tooltip,contents);
                    this.fetchContentHtml(contents[0]).then(
                      (result) => {
                        this.partCContainers[i].isLoadFinished = true;
                        this.partCContainers[i].contents = contents;
                      },
                      (error) => {
                        this.partCContainers[i].isLoadFinished = true;
                        contents[0].htmlContent = error.error.text;
                        this.partCContainers[i].contents = contents;
                      }
                    );
                  }
                  else {
                    this.partCContainers[i].isLoadFinished = true;
                  }
                },
                (error) => {
                  this.partCContainers[i].isLoadFinished = true;
                }
              );
            }
            this.partCContainers[i].bg = this.bgColors[bgIndex];
            bgIndex++;
            if (bgIndex > this.bgColors.length)
              bgIndex = 0;
          }
        },
        (error) => console.log(error)
      );



    })
  }

  fetchContainersAsync(containerType: any, isContent: boolean) {
    return new Promise((resolve, reject) => {
      let containers: Container[] = [];
      let url = 'api/rest/containers';
      let params = { params: { type: containerType } };
      this.containerService.getData(url, params, false).subscribe(result => {
        if (result != null) {
          containers = result as Container[];
          for (let i = 0; i < containers.length; i++)
            containers[i].contents = [];
          resolve(containers);
          if (isContent) {
            this.fetchContentAsync(containers).then(
              (result) => resolve(result),
              (error) => console.log(error)
            );
          }
        }
      }, error => reject(error));
    });
  }

  fetchContentAsync(containers: Container[]) {
    return new Promise((resolve, reject) => {
      for (let i = 0; i < containers.length; i++) {
        let url = 'api/rest/containers/' + containers[i].id + '/contents/';
        let params = {};
        this.contentService.getData(url, params, false).subscribe(result => {
          if (result != null) {
            let items = result as Content[];
            containers[i].contents = items;
            //console.log('this is contents : ', items);
          }
        }, error => reject(error));
      }
      resolve(containers);
    });
  }

  fetchContentByIdContainerAsync(containerId: number) {
    return new Promise((resolve, reject) => {
      let items: Content[] = [];
      let url = 'api/rest/containers/' + containerId + '/contents/';
      let params = {};
      this.contentService.getData(url, params, false).subscribe(result => {
        if (result != null) {
          items = result as Content[];
          //console.log('this is contents : ',items);ò
          resolve(items);
        }
      }, error => reject(error));
    });
  }

  fetchContentHtml = (content: Content) => {
    return new Promise((resolve, reject) => {

      let url = content.linkedUrl;
      let params = {};
      this.containerService.getData(url, params, false).subscribe(result => {
        if (result != null) {
          resolve(result);
        }
      }, error => reject(error));
    });
  }

  /* Part D Icone a sinistra */
  openPartD = (content: any) => {
    const contentId = content.id;
    switch (contentId) {
      case 40: {
        this.modalService.open(PhoneBookComponent, { windowClass: "myCustomModalClass", backdrop: 'static' });
        break;
      }
      case 41: {
        window.open('listini-vendita', '_blank');
        break;
      }
      case 42: {
        const link = this.partDContainers[0].contents.find(x => x.id == contentId).linkedUrl;
        const url = 'api/rest/getPromotional';
        const params = { params: { link: link } };
        this.containerService.getData(url, params, false).subscribe(result => {
          if (result != null) {
            const res = result as Container;
            window.open(res.linkedUrl, '_blank');
          }
        }, error => console.log(error));
        break;
      }
      case 49: {
        window.open('arcadoc', '_blank');
        break;
      }
      case 52: {
        this.modalService.open(UserComponent, { windowClass: "myCustomModalClass", backdrop: 'static' });
        break;
      }
      default: {
        // In caso di un container generico di tipo ICON (come i pulsanti), apro il link (se esiste) in un'altra finestra
        const link = this.partDContainers[0].contents.find(x => x.id == contentId).linkedUrl;
        if (this.isURL(link)) {
          console.log(`Opening link ${link} found on content ${content}`);
          window.open(link, '_blank');
          break;
        } else {
          console.warn('No valid resource found on content', content);
          break;
        }
      }
    }
  }

  openPartB = (content: any) => {
    const contentId = content.id;
    switch (contentId) {
      case 40: {
        this.modalService.open(PhoneBookComponent, { windowClass: "myCustomModalClass", backdrop: 'static' });
        break;
      }
      case 41: {
        window.open('listini-vendita', '_blank');
        break;
      }
      case 42: {
        const link = this.partDContainers[0].contents.find(x => x.id == contentId).linkedUrl;
        const url = 'api/rest/getPromotional';
        const params = { params: { link: link } };
        this.containerService.getData(url, params, false).subscribe(result => {
          if (result != null) {
            const res = result as Container;
            window.open(res.linkedUrl, '_blank');
          }
        }, error => console.log(error));
        break;
      }
      case 49: {
        window.open('arcadoc', '_blank');
        break;
      }
      case 52: {
        this.modalService.open(UserComponent, { windowClass: "myCustomModalClass", backdrop: 'static' });
        break;
      }
      default: {
        // In caso di un container generico di tipo ICON (come i pulsanti), apro il link (se esiste) in un'altra finestra
        const link = this.partBContainers[0].contents.find(x => x.id == contentId).linkedUrl;
        if (this.isURL(link)) {
          console.log(`Opening link ${link} found on content ${content}`);
          window.open(link, '_blank');
          break;
        } else {
          console.warn('No valid resource found on content', content);
          break;
        }
      }
    }
  }

  //TODO: ULTIMI DIECI DOCUMENTI
  openPartC = (content: any) => {
    const contentId = content.id;
    const url = environment.baseUrl + "arcadocqualita-detail/" + contentId;
    window.open(url);
  }

  isURL(str: string) {
    // Andrebbe fatto con le regex ma non le conosco
    const resourcelower = str.toLowerCase();
    const result = resourcelower.startsWith('http') || resourcelower.startsWith('./');
    return result;
  }

  startLoading() {
    this.loadingBar.start();
  }

  stopLoading() {
    this.loadingBar.complete();
  }
  public trackByFn(index, item) {
    if (!item) return null;
    return index;
  }
}
